export class AscendError extends Error {
    isAscendError = true;
    type;
    name;
    errorCode;
    statusCode;
    message;
    userMessage;
    constructor(args, e) {
        const options = e instanceof Error ? { cause: e } : undefined;
        super(`[${args.statusCode}]${args.errorCode}: ${args.message}`, options);
        this.type = args.type;
        this.name = args.name;
        this.statusCode = args.statusCode;
        this.errorCode = args.errorCode;
        this.message = args.message;
        this.userMessage = args.userMessage;
    }
    toJSON() {
        return {
            type: this.type,
            statusCode: this.statusCode,
            errorCode: this.errorCode,
            message: this.message,
            userMessage: this.userMessage,
        };
    }
    static isAscendError(e) {
        if (!(e instanceof Error)) {
            return false;
        }
        return !!e.isAscendError;
    }
}
//# sourceMappingURL=ascend-error.js.map